import * as React from 'react'
import { FC } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { SideDrawer } from '@sales-center/components'
import { AddServiceLocationForm } from '@user/components/Location/AddServiceLocationForm/AddServiceLocationForm'

interface Props {
  entityId: number
  externalLocationId: string
  entityType: ENTITY_TYPES
  onClose: () => void
  open: boolean
}

export const CreateLocationDrawer: FC<Props> = (props) => {
  const { onClose, open, externalLocationId } = props

  return (
    <SideDrawer
      headerWithoutClose
      title="Create Agreement"
      open={open}
      onClose={onClose}
      width={495}
    >
      <AddServiceLocationForm
        {...props}
        entityBranchId={''}
        fromAgreement={true}
        isBillingLocation={false}
        matched={Boolean(externalLocationId)}
        mode={'Add'}
        externalLocationId={externalLocationId}
      />
    </SideDrawer>
  )
}
CreateLocationDrawer.displayName = 'CreateLocationDrawer'
